import { schema } from 'normalizr';

import { processGroupLinks } from '../strategies/groupLink';

export const groupLinksSchema = new schema.Entity('groupLinks', {}, { processStrategy: processGroupLinks });
